import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { TextIcon24Regular } from "../../../../../icons2022/FileTypeTextIcon/TextIcon24Regular";
import { TextIcon32Regular } from "../../../../../icons2022/FileTypeTextIcon/TextIcon32Regular";
import { TextIcon64Regular } from "../../../../../icons2022/FileTypeTextIcon/TextIcon64Regular";
export var TextIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(TextIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(TextIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(TextIcon64Regular, null);
  }
}, 'TextIcon');